<!-- 联系方式组件 -->
<template>
  <div class="contact">
    <ul class="mainbox">
        <li v-for="item in items" :key="item.text">
            <a :href="item.html" class="link">
                <!-- 图标 -->
                <div class="icon">
                    <Icon :type="item.type"></Icon>
                </div>
                <!-- 文字 -->
                <span class="text">
                    {{ item.text }}
                </span>
            </a>
            <div class="pop" v-show="item.img!=''">
                <img src="@/img/wei.png" v-show="item.img ==='@/img/wei.png'">
                <img src="@/img/QQ.png" v-show="item.img ==='@/img/QQ.png'">
            </div>
        </li>
    </ul>
  </div>
</template>

<script>
import Icon from './Icon.vue';
export default {
    components:{
        Icon,
    },
    data(){
        return {
            items:[
            {
                type:"QQ",
                text:"827868770",
                img:"@/img/QQ.png",
                html:"tencent://message/?Menu=yes&uin=827868770&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a595b1714f9d45"
            },
            {
                type:"wei",
                text:"chen827868770",
                img:"@/img/wei.png",
                html:""
            },
            {
                type:"phone",
                text:"18674926231",
                img:"",
                html:""
            },
            {
                type:"xinxi",
                text:"827868770@qq.com",
                img:"",
                html:"mailto:827868770@qq.com"
            }
            ],
        }
    }
}
</script>

<style scoped lang="less">
.contact{
    width: 100%;
    list-style: none;
    padding: 10px;
}

.link{
    color: #ccc;
    cursor: pointer;
}
.link:hover{
    background: transparent;
    color:#fff;

}
.link .icon{
    display: inline;
    vertical-align:-1.5px;
}
li .link:hover ~.pop{
        transform: scaleY(1);
    }
.link .text{
    margin-left: 5px;
}
.mainbox{
    display: grid;
    grid-template-columns:auto;
    row-gap: 10px;
}
.mainbox li{
    position: relative;
}
.iconfont{
    font-size: 22px;
}

.pop{
    position:absolute;
    background: #fff;
    left:3%;
    bottom: 27px;
    padding: 10px 15px;
    border-radius: 5px;
    img{
    width: 150px;
    height: 150px;
    // border: 2px solid ;
    }
    &::after{
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        width: 8px;
        height: 8px;
        background: #fff;
        bottom: -4px;
    }
    transform: scaleY(0);
    transform-origin: center bottom;
    transition: 0.3s ease-in-out;
}
</style>